// import React, { useState } from 'react';
import LeaveIcon from '../../src/assests/leave_request.png';
import ApproveIcon from '../../src/assests/leave_approval.png';
import AttendanceIcon from '../../src/assests/attendance.png';
import HolidaysIcon from '../../src/assests/Holidays.png';
import ShiftDetails from './ShiftDetails';
import { FaAngleDoubleLeft } from "react-icons/fa";
import AttendanceHistory from './AttendanceHistory';
import RequestForLeave from './RequestForLeave';
import Payslips from "../../src/assests/payslips.png"
import PaySlips from './PaySlips';
import LeaveReq from "../../src/assests/levreq.png"
import ViewLeaves from './ViewLeaves';
import LeaveManagement from './LeaveManagement';
import { useSearchParams } from 'react-router-dom';
import HolidaysListing from './HolidaysListing';
import { getNotifiedHoliday } from "../components/utils/holidayUtils"
import BreakTimer from './BreakTimer';
import FeedbackForm from './FeedbackForm';

const CheckIn = () => <div className="p-4">🔓 Check In Component</div>;
const CheckOut = () => <div className="p-4">🔒 Check Out Component</div>;

const DashboardCard = ({ title1, title2, iconSrc, iconBg, onClick }) => (
  <div
    onClick={onClick}
    className="cursor-pointer bg-white border border-gray-300 rounded-xl p-6 text-center shadow-none hover:shadow-md transition-all duration-200"
  >
    <div
      className={`w-20 h-20 mx-auto mb-3 rounded-xl flex items-center justify-center ${iconBg}`}
    >
      <img src={iconSrc} alt={`${title1} ${title2}`} className="w-10 h-10 object-contain" />
    </div>
    <div className="text-sm text-gray-800">{title1}</div>
    <div className="text-sm text-gray-800">{title2}</div>
  </div>
);


const HomeScreen = () => {
  // const [activeComponent, setActiveComponent] = useState(null);

  const [searchParams, setSearchParams] = useSearchParams();
  const activeComponent = searchParams.get('component');

  // const handleCardClick = (key) => {
  //   setSearchParams({ component: key });
  // };

  const notifiedHoliday = getNotifiedHoliday();

  const componentsMap = {
    leaveRequest: <RequestForLeave />,
    leaveDetails: <ViewLeaves />,
    leaveApproval: <LeaveManagement />,
    attendance: <AttendanceHistory />,
    holidays: <HolidaysListing />,
    checkIn: <CheckIn />,
    checkOut: <CheckOut />,
    payslips: <PaySlips />,
    lunchBreak: <BreakTimer />,
    feedback: <FeedbackForm />,
  };

  const cards = [
    {
      key: 'leaveRequest',
      title1: 'Leave',
      title2: 'Request',
      iconSrc: LeaveReq,
      iconBg: 'bg-[#FFF2F2]',
    },
    {
      key: 'leaveDetails',
      title1: 'Leave Request',
      title2: 'Details',
      iconSrc: LeaveIcon,
      iconBg: 'bg-[#FFF2F2]',
    },
    {
      key: 'leaveApproval',
      title1: 'Leave',
      title2: 'Approval',
      iconSrc: ApproveIcon,
      iconBg: 'bg-[#FFF2F2]',
    },
    {
      key: 'attendance',
      title1: 'Attendance',
      title2: 'Regularization',
      iconSrc: AttendanceIcon,
      iconBg: 'bg-[#FFF2F2]',
    },
    {
      key: 'lunchBreak',
      title1: 'Break',
      iconSrc: AttendanceIcon,
      iconBg: 'bg-[#FFF2F2]'
    },
    {
      key: 'holidays',
      title1: 'Holidays',
      title2: 'Listing',
      iconSrc: HolidaysIcon,
      iconBg: 'bg-[#FFF2F2]',
    },
    {
      key: 'payslips',
      title1: 'PaySlips',
      iconSrc: Payslips,
      iconBg: 'bg-[#FFF2F2]',
    },
    // {
    //   key: 'checkIn',
    //   title1: 'Check-In',
    //   iconSrc: CheckInIcon,
    //   iconBg: 'bg-[#FFF2F2]',
    // },
    // {
    //   key: 'checkOut',
    //   title1: 'Check-Out',
    //   iconSrc: CheckOutIcon,
    //   iconBg: 'bg-[#FFF2F2]',
    // },
    {
      key: 'feedback',
      title1: 'Feedback',
      iconSrc: Payslips,
      iconBg: 'bg-[#FFF2F2]',
    }
  ];

  return (
    <>
      {!activeComponent && notifiedHoliday && (
        <div
          className={`${notifiedHoliday.type === "today" ? "bg-yellow-100" : "bg-green-100"
            } border-l-4 ${notifiedHoliday.type === "today" ? "border-yellow-600" : "border-green-600"
            } text-gray-800 p-4 rounded-md max-w-3xl mx-auto my-2`}
        >
          <div className="flex justify-between items-center rounded text-xs">
            {notifiedHoliday && (
              <p className="truncate">
                {notifiedHoliday.type === "today" ? (
                  <>🎉 Happy {notifiedHoliday.name}!</>
                ) : (
                  <>
                    Upcoming Holiday on{" "}
                    <b>
                      {new Date(notifiedHoliday.date).toLocaleDateString("en-IN", {
                        day: "numeric",
                        month: "short",
                      })}
                    </b>&nbsp;
                    <span className="font-semibold">{notifiedHoliday.name}</span>
                  </>
                )}
              </p>
            )}
            <button
              onClick={() => setSearchParams({ component: "holidays" })}
              className="text-blue-600 underline hover:text-blue-800 text-xs"
            >
              View
            </button>
          </div>

        </div>
      )}


      {!activeComponent && (
        <>
          <div className="flex items-center justify-center text-orange-700 text-xs rounded-md px-3 py-1 mb-2">
            <span className="italic font-medium">
              *Kindly ensure you log in strictly from your designated zone!!
            </span>
          </div>
          <div className="justify-center items-center mb-3">
            <ShiftDetails />
          </div>
        </>
      )}
      <div className="min-h-screen">
        {activeComponent ? (
          <>
            <div className='flex gap-2' onClick={() => setSearchParams({})}
            >
              <button
                className="pl-4 rounded cursor-pointer"
              >
                {/* ←  */}
                <FaAngleDoubleLeft />
              </button>
              <p className='text-gray-500 text-sm hover:underline cursor-pointer hover:text-gray-900 '>Back</p>
            </div>
            {componentsMap[activeComponent]}
          </>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-2 gap-3 max-w-4xl mx-auto">
            {cards.map((card) => (
              <DashboardCard
                key={card.key}
                title1={card.title1}
                title2={card.title2}
                iconSrc={card.iconSrc}
                iconBg={card.iconBg}
                onClick={() => setSearchParams({ component: card.key })}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );

};

export default HomeScreen;
